export default  {
  bindings: {
    page: '='
  },
  controller: 'pageContentGenericController',
  template: require('../views/pageContent.treatments.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/components/pageContent.treatments.component.js